import { RouteProp, useNavigation, useRoute } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { Button, Page, Text, VStack } from "@towersystems/roam-common-native";
import { useState } from "react";
import { ScrollView } from "react-native";
import { Image, Spacings, View } from "react-native-ui-lib";
import { LoadingScreen } from "../../../../components/LoadingScreen/LoadingScreen";
import { ProductPlaceholder } from "../../../../components/ProductPlaceholder";
import { ProductRootPartialScreenParamList } from "../../../../types";
import {
  useProductAwaitState,
  useProductPartialRootScreenContext,
} from "../../../../utilities/products/hooks";
import { ProductErrorGuard } from "../../components";
import { baseImageStyle } from "./constants";

const imageContainerStyle = {
  width: "100%",
  aspectRatio: 1, // Set the aspect ratio to maintain image proportions
  maxWidth: 200,
  maxHeight: 200,
};

export function ProductPreviewScreen() {
  const { label, primaryAction } = useProductPartialRootScreenContext();
  const [loading, setLoading] = useState<boolean>(false);

  const navigation =
    useNavigation<StackNavigationProp<ProductRootPartialScreenParamList>>();

  const {
    params: { productId },
  } =
    useRoute<
      RouteProp<ProductRootPartialScreenParamList, "ProductPreviewScreen">
    >();

  const productState = useProductAwaitState(productId);

  const product = productState?.data;

  const imageMarkup = product?.imageUrl ? (
    <Image
      resizeMode="cover"
      source={{ uri: product.imageUrl }}
      style={baseImageStyle}
    />
  ) : (
    <ProductPlaceholder />
  );

  function handlePrimaryAction() {
    if (!product) return;

    setLoading(true);
    primaryAction(product)
      .finally(() => {
        setLoading(false);
      })
      .catch(console.log);
  }

  const footer = product ? (
    <Button
      style={{
        display: "flex",
      }}
      isAction
      disabled={productState.isLoading}
      {...{ label, loading }}
      onPress={handlePrimaryAction}
    />
  ) : null;

  return (
    <ProductErrorGuard
      error={productState?.isError ? productState.errorMsg : undefined}
    >
      <Page
        footerStyles={{ padding: 0, borderTopWidth: 0 }}
        scrollable
        cover
        footer={footer}
      >
        {product && !productState.isLoading ? (
          <View flex>
            <View
              style={{
                display: "flex",
                alignItems: "center",
                flex: 1,
              }}
            >
              <ScrollView>
                <VStack spacing={Spacings.s5}>
                  <View
                    style={{
                      ...imageContainerStyle,
                      alignSelf: "center",
                      marginBottom: Spacings.s5,
                    }}
                  >
                    {imageMarkup}
                  </View>
                  <View>
                    <Text
                      variant="heading2"
                      color="subdued"
                      style={{ marginBottom: Spacings.s2, textAlign: "center" }}
                    >
                      {product.stockNumber}
                    </Text>
                    <Text
                      numberOfLines={2}
                      variant="title"
                      style={{ textAlign: "center" }}
                    >
                      {product.displayName || product.name}
                    </Text>
                  </View>

                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="outline"
                      isAction
                      size="compact"
                      label="More info"
                      onPress={() =>
                        navigation.navigate("ProductDetailScreen", {
                          productId: productId,
                        })
                      }
                    />
                  </View>
                </VStack>
              </ScrollView>
            </View>
            <View
              style={{
                display: "flex",

                flexDirection: "column-reverse",
                paddingTop: Spacings.s5,
                width: "100%",
              }}
            ></View>
          </View>
        ) : (
          <LoadingScreen message="Loading product preview." />
        )}
      </Page>
    </ProductErrorGuard>
  );
}
